import React from 'react'
import { Modal } from 'react-bootstrap'
import {getTaskTypeIconParser} from '../shared/enums/task-type-icon-parser'
import {getIntervalParser} from '../shared/enums/interval-enum-parser'
import {getPackageTypeParser} from '../shared/enums/package-type-parser'
import {acceptReprice, rejectReprice} from '../api'

export default React.createClass({
    getInitialState: function() {
       return {
           iconSrc: '/common/latest/images/consumer/history-icons/REPRICE-flat.png',
           taskTitle: '',
           address: '',
           orderNumber: '',
           content: '',
           contractorComment: '',
           newFrequency: '',
           newPackage: '',
           newSchedule: '',
           oldFrequency: '',
           oldPackage: '',
           oldSchedule: '',
           newCost: '',
           oldCost: '',
           newTracingUrl: '',
           oldTracingUrl: '',
           changedFrequency: '',
           changedPackage: '',
           changedSchedule: '',
           
       }
    },
  componentWillReceiveProps: function(nextProps) {
    if(nextProps.repriceCard !== '') {
      let newTask = nextProps.repriceCard.newTask
      let oldTask = nextProps.repriceCard.mobileTask

      let iconTypeInfo = getTaskTypeIconParser(nextProps.repriceCard.taskType)
      let taskTitle = iconTypeInfo.prettify + ' Reprice'
      let formattedAddress = newTask.customerAddress.googleAddress
      let formattedOldFrequency = getIntervalParser(oldTask.interval).capitalizedText
      let formattedOldPackage = getPackageTypeParser(oldTask.packageType).capitalizedText

      let formattedNewFrequency = getIntervalParser(newTask.interval).capitalizedText
      let formattedNewPackage = getPackageTypeParser(newTask.packageType).capitalizedText
      
      if(formattedNewFrequency !== formattedOldFrequency) {
        this.setState({changedFrequency: '#eff865'})
      }
      if(formattedNewPackage !== formattedOldPackage) {
        this.setState({changedPackage: '#eff865'})
      }
      if(newTask.schedule !== oldTask.schedule) {
        this.setState({changedSchedule: '#eff865'})
      }

      this.setState({taskTitle: taskTitle, address: formattedAddress, orderNumber: oldTask.taskId, content: nextProps.repriceCard.content, contractorComment: newTask.comment,
      newFrequency: formattedNewFrequency, newPackage: formattedNewPackage, newSchedule: newTask.schedule, oldFrequency: formattedOldFrequency, oldPackage: formattedOldPackage, oldSchedule: oldTask.schedule,
      newCost: nextProps.repriceCard.newCost, oldCost: nextProps.repriceCard.cost, newTracingUrl: newTask.mapTracingUrl, oldTracingUrl: oldTask.mapTracingUrl
      })
    }
  },
  acceptReprice: function() {
    acceptReprice(this.props.repriceCard.mobileTask.taskId, this.props.repriceCard.messageId).then((response) => {
      if(response === 'okay') {
        this.props.openNotificationModal('reprice-modal', "Approved Reprice!", "Your task has been repriced!")
        this.props.hide()
      } 
      else {
        this.props.openNotificationModal('reprice-modal', "Processing Error", "There was an error processing your rating.")
        this.props.hide()
      }
    })
  },
  rejectReprice: function() {
    rejectReprice(this.props.repriceCard.mobileTask.taskId, this.props.repriceCard.messageId).then((response) => {
      if(response === 'okay') {
        this.props.openNotificationModal('reprice-modal', "Reprice Rejected!", "We are sorry that the changes to your task did not meet your expectations. TaskEasy will review this and contact you if necessary.")
        this.props.hide()
      } 
      else {
        this.props.openNotificationModal('reprice-modal', "Processing Error", "There was an error processing your rating.")
        this.props.hide()
      }
    })
  },
  render: function () {
    return (
      <div>
          <Modal show={this.props.show} onHide={this.props.hide} dialogClassName='my-modal-size'>
            <Modal.Header closeButton>
              <img src={this.state.iconSrc} className='img-responsive center-block pull-down-xs-3' alt='' />
              <h2 className='text-center'>{this.state.taskTitle}</h2>
              <div className='text-center row pull-down-xs-2'>
                <div className='text-center'>
                  <h5 className='text-center' style={{fontSize: 25}}>{this.state.address}</h5>
                  <p><b>Order #{this.state.orderNumber}</b></p>
                  <p style={{width:'80%', margin:'auto'}}>{this.state.content}</p>
                  <p style={{width:'80%', maring:'auto'}}>{this.state.contractorComment}</p>
                </div>
              </div>
              <div className='row modal-buttons-container'>
                <div className='col-xs-12 col-md-6 text-center pull-down-xs-3 pull-down-sm-2'>
                            <button className='btn btn-success btn-sm modal-button-sm' onClick={this.acceptReprice}>Accept Reprice</button>
                          </div>
                <div className='col-xs-12 col-md-6 text-center pull-down-xs-3 pull-down-sm-2'>
                            <button className='btn btn-info btn-sm modal-button-sm' onClick={this.rejectReprice}>Reject</button>
                          </div>
              </div>
              <div className='row pull-down-xs-2'>
                <div className='col-xs-12 col-sm-6'>
                <div style={{margin: 5, marginTop: 10, padding: 10, backgroundColor: '#E1E1E1'}}>
                    <h3 style={{textAlign: 'center'}}>Original Price</h3>
                    <div className='pull-down-sm-2'>
                      <div style={{marginLeft: 5, marginRight: 5}}>
                        <div style={{height: 40}}>
                            <h6 className='baseline-color' style={{textAlign: 'left', padding: '0 0 0 10px'}}>Frequency: <span style={{fontWeight: 400}} className='cerulean-blue-color'>{this.state.oldFrequency}</span></h6>
                          </div>
                          <div style={{height: 40}}>
                            <h6 className='baseline-color' style={{textAlign: 'left', padding: '0 0 0 10px'}}>Service Plan: <span style={{fontWeight: 400}} className='cerulean-blue-color'>{this.state.oldPackage}</span></h6>
                          </div>
                          <div style={{height: 30}}>
                            <h6 className='baseline-color' style={{textAlign: 'left', padding: '0 0 0 10px'}}>Schedule: <span style={{fontWeight: 400}} className='cerulean-blue-color'>{this.state.oldSchedule}</span></h6>
                          </div>
                      </div>
                      <div className='pull-down-xs-2'>
                        <div style={{width:'65%', margin:'auto', paddingTop:'10px', paddingBottom:'5px'}} className='medium-gray-background'>
                            <h6 className='white-color text-center'><span style={{fontSize:'28px'}} className='spacer'><b>${this.state.oldCost}</b></span> /per service</h6>
                        </div>
                      </div>
                      <div className='text-center pull-down-xs-2'>
                        <img style={{width: '100%'}} src={this.state.oldTracingUrl} alt="Old Tracing"/>
                      </div>
                  </div>
                </div>
                </div>
                <div className='col-xs-12 col-sm-6'>
                <div style={{margin: 5, marginTop: 10, padding: 10, backgroundColor: '#E1E1E1'}}>
                    <h3 style={{textAlign: 'center'}}>New Price</h3>
                    <div className='pull-down-sm-2'>
                      <div style={{marginLeft: 5, marginRight: 5}}>
                        <div style={{height: 40, backgroundColor: this.state.changedFrequency}}>
                            <h6 className='baseline-color' style={{textAlign: 'left', padding: '0 0 0 10px'}}>Frequency: <span style={{fontWeight: 400}} className='cerulean-blue-color'>{this.state.newFrequency}</span></h6>
                          </div>
                          <div style={{height: 40, backgroundColor: this.state.changedPackage}}>
                            <h6 className='baseline-color' style={{textAlign: 'left', padding: '0 0 0 10px'}}>Service Plan: <span style={{fontWeight: 400}} className='cerulean-blue-color'>{this.state.newPackage}</span></h6>
                          </div>
                          <div style={{height: 30, backgroundColor: this.state.changedSchedule}}>
                            <h6 className='baseline-color' style={{textAlign: 'left', padding: '0 0 0 10px'}}>Schedule: <span style={{fontWeight: 400}} className='cerulean-blue-color'>{this.state.newSchedule}</span></h6>
                          </div>
                      </div>
                      <div className='pull-down-xs-2'>
                        <div style={{width:'65%', margin:'auto', paddingTop:'10px', paddingBottom:'5px'}} className='sushi-background'>
                            <h6 className='white-color text-center'><span style={{fontSize:'28px'}} className='spacer'><b>${this.state.newCost}</b></span> /per service</h6>
                        </div>
                      </div>
                      <div className='text-center pull-down-xs-2'>
                        <img style={{width: '100%'}} src={this.state.newTracingUrl} alt="New Tracing"/>
                      </div>
                  </div>
                </div>
                </div>
              </div>
            </Modal.Header>
          </Modal>
        </div>
  
    )
  }
})



// WEBPACK FOOTER //
// ./src/components/modals/reprice-modal.jsx